var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24Save(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23828 2.98925C7.20161 2.99016 7.16505 2.99375 7.12891 3H5.75C4.24011 3 3 4.24011 3 5.75V18.25C3 19.7599 4.24011 21 5.75 21H6.62695C6.70747 21.0132 6.7896 21.0132 6.87012 21H17.127C17.2075 21.0132 17.2896 21.0132 17.3701 21H18.25C19.7599 21 21 19.7599 21 18.25V7.75C21 7.64407 20.9775 7.53935 20.9341 7.44273C20.8906 7.34612 20.8272 7.2598 20.748 7.18945L16.248 3.18945C16.1108 3.06747 15.9336 3.00006 15.75 3H15.373C15.2925 2.98677 15.2104 2.98677 15.1299 3H7.37305C7.32854 2.99237 7.28343 2.98877 7.23828 2.98925ZM5.75 4.5H6.5V7.25C6.5 8.20747 7.29252 9 8.25 9H14.25C15.2075 9 16 8.20747 16 7.25V4.97558L19.5 8.08691V18.25C19.5 18.9491 18.9491 19.5 18.25 19.5H18V13.75C18 12.7925 17.2075 12 16.25 12H7.75C6.79252 12 6 12.7925 6 13.75V19.5H5.75C5.05089 19.5 4.5 18.9491 4.5 18.25V5.75C4.5 5.05088 5.05089 4.5 5.75 4.5ZM8 4.5H14.5V7.25C14.5 7.39752 14.3975 7.5 14.25 7.5H8.25C8.10248 7.5 8 7.39752 8 7.25V4.5ZM7.75 13.5H16.25C16.3975 13.5 16.5 13.6025 16.5 13.75V19.5H7.5V13.75C7.5 13.6025 7.60248 13.5 7.75 13.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24Save);
export default __webpack_public_path__ + "static/media/icn_24x24_save.ff2b11fa40c63c143a62f96b33f80b4d.svg";
export { ForwardRef as ReactComponent };